import { getLocalizedContent as getLocalizedBrand } from '@zocdoc/branding/brands/getLocalizedContent';
import { defineMessages } from 'react-intl';

const LOCALIZED_STRINGS = defineMessages({
    LOCALE: {
        id: 'CurrentLocale',
        defaultMessage: 'en',
    },
});

export default function getLocalizedContent({ theme, intl, path }) {
    const locale = intl.formatMessage(LOCALIZED_STRINGS.LOCALE);
    return getLocalizedBrand(theme, locale, path);
}
